import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=74f04c0b&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=74f04c0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f04c0b",
  null
  
)

export default component.exports